import { useSearchParams } from "react-router-dom";
import { Seo } from "@/site/seo";
import { Heading } from "@/site/components/Section";
import LeadForm from "@/site/components/LeadForm";
import { WhereWeAre } from "@/site/components/Pricing";
import { SITE } from "@/site/content";

export default function PilotPage() {
  const [q] = useSearchParams();
  const intent = q.get("intent") === "pilot" ? "pilot" : "walkthrough";
  return (
    <>
      <Seo title="Start a pilot" description="Start a Postern pilot or book a 30-minute walkthrough. Bring your account list; price a real deal in the first session." noindex={false} />
      <section className="section">
        <div className="wrap cta-band__grid">
          <div>
            <Heading eyebrow="Start a pilot" title="Proof, not a pitch." lede="See it work on your own accounts — not a demo." />
            {SITE.email && <p style={{ marginTop: -18, marginBottom: 24, fontSize: 14.5, color: "var(--faint)" }}>Prefer email? <a href={`mailto:${SITE.email}`} style={{ color: "var(--highlight-dark)" }}>{SITE.email}</a></p>}
            <WhereWeAre />
          </div>
          <LeadForm intent={intent} source="pilot_page" showTabs={false} />
        </div>
      </section>
    </>
  );
}
